import * as React from 'react';
import {PageCheckoutPanelProps} from './page-checkout-panels';
import {Form as IForm, FormField, FormFields} from '../types/form';
import {Form} from './form';
import {style} from 'typestyle';
import {px} from 'csx';

export interface PageCheckoutAddCardFields extends FormFields {
  name: FormField<string>;
  number: FormField<string>;
  cvc: FormField<string>;
  exp: FormField<string>;
}

export type PageCheckoutAddCardModel = IForm<PageCheckoutAddCardFields>;

export interface PageCheckoutAddCardProps extends PageCheckoutPanelProps {
  onChange(field: string, value: any): void;
  i18n?: {
    title: string;
  }
}

const DEFAULT_I18N = {
  title: 'Add payment method'
};

export class PageCheckoutAddCard extends React.Component<PageCheckoutAddCardProps, any> {
  render() {
    const { i18n = DEFAULT_I18N, model, onChange } = this.props;

    return (
      <div className={PageCheckoutAddCard.styles.container}>
        <Form
          model={model.addCardForm}
          onChange={onChange}
          noButtons={true}
          autoFocus="name"
        />
      </div>
    )
  }

  static styles = {
    container: style({
      maxWidth: px(640),
      margin: '0 0 40px 0',
      $nest: {
        '&> h5': {
          margin: '0 0 40px 0'
        }
      }
    })
  }
};